import FormControls from 'component/FormControls';
import Page from 'component/Page';
import { useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  focusElement,
  getFormData,
  showConfirm,
  emailValidate,
  showToast,
} from 'util/utils';
import { RiEyeCloseLine } from 'react-icons/ri';
import { ImEye } from 'react-icons/im';

const UserUpdate = ({ data = { id: null, valid: true }, onUpdated }) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const [ showPassword, setShowPassword ] = useState(false);
  //------------------------FUNCTIONS----------------------------------------------------------
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();


    let formData = getFormData(e.target, {
      rawCol: {
        customerId: true,
        email: true,
        password: true,
        passwordConfirm: true,
        usernameKanji: true,
        usernameHira: true,
        phoneNumber: true,
      },
    });
    let customerIdUpdate = true;
    if (!formData.customerId) {
      // showToast(string.ACCOUNT_CUSTOMER_ID_EMPTY_ERROR);
      // focusElement('#customerId');
      // return;
      customerIdUpdate = false;
    }
    if (!formData.email) {
      showToast(string.MAIL_ADDRESS_EMPTY_ERR);
      focusElement('#email');
      return;
    }
    if (!emailValidate(formData.email)) {
      showToast(string.MAIL_ADDRESS_FORMAT_ERR);
      focusElement('#email');
      return;
    }
    if (!formData.usernameKanji) {
      showToast(string.USERNAME_EMPTY_ERR);
      focusElement('#usernameKanji');
      return;
    }
    if (!formData.usernameHira) {
      showToast(string.FURIGANA_EMPTY_ERR);
      focusElement('#usernameHira');
      return;
    }
    if (!formData.phoneNumber) {
      showToast(string.PHONENUMBER_EMPTY_ERR);
      focusElement('#phoneNumber');
      return;
    }
    if (!formData.password) {
      showToast(string.PASSWORD_EMPTY_ERR);
      focusElement('#password');
      return;
    }
		if (!formData.passwordConfirm) {
			showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
			focusElement('#passwordConfirm');
			return;
		}
		if (formData.password !== formData.passwordConfirm) {
			showToast(string.PASSWORD_CONFIRM_ERR);
			focusElement('#password');
			return;
		}
    // if (!showPassword) {
    //   if (!formData.passwordConfirm) {
    //     showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
    //     focusElement('#passwordConfirm');
    //     return;
    //   }
    //   if (formData.password !== formData.passwordConfirm) {
    //     showToast(string.PASSWORD_CONFIRM_ERR);
    //     focusElement('#password');
    //     return;
    //   }
    // }
    let updateData = {
      email: formData.email,
      password: formData.password,
      usernameKanji: formData.usernameKanji,
      usernameHira: formData.usernameHira,
      phoneNumber: formData.phoneNumber,
    };
    if (customerIdUpdate === true) {
      updateData = {
        customerId: formData.customerId,
        ...updateData,
      };
    }
    showConfirm({
      body: string.ACCOUNT_UPDATE_CONFIRM,
      defaultAction: () => {
        sendPut({
          url: Urls.admin.account,
          body: {
            id: data?.id,
            ...updateData,
            accountRole: 1,
          },
        }).then((res) => {
          showToast(string.ACCOUNT_UPDATE_SUCCESS, 'success');
          onUpdated(res);
        }).catch((e) => { });
      },
    });
  };

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <Page
        title={string.ACCOUNT_UPDATE_TITLE}
        body={
          <>
            <Form onSubmit={onSubmit}>
              <FormControls
                data={data}
                controls={[
                  {
                    id: 'customerId',
                    title: string.ACCOUNT_CUSTOMER_ID,
                  },
                  {
                    id: 'email',
                    title: string.SIGNUP_MAIL_TITLE,
                  },
                  {
                    id: 'usernameKanji',
                    title: string.SIGNUP_NAME_TITLE,
                  },
                  {
                    id: 'usernameHira',
                    title: string.SIGNUP_FURIGANA_TITLE,
                  },
                  {
                    id: 'phoneNumber',
                    title: string.SIGNUP_PHONE_TITLE,
                  },
                  {
                    id: 'password',
                    title: string.SIGNUP_PASSWORD_TITLE,
                    type: showPassword ? 'text' : 'password',
                    defaultValue: '',
                    footer: showPassword ? (
                      <>
                        <ImEye
                          onClick={() => {
                            setShowPassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <RiEyeCloseLine
                          onClick={() => {
                            setShowPassword(true);
                          }}
                        />
                      </>
                    ),
                  },
                  {
                    id: 'passwordConfirm',
                    title: string.SIGNUP_CONFIRM_TITLE,
                    defaultValue: '',
                    type: showPassword ? 'text' : 'password',
                    footer: showPassword ? (
                      <>
                        <ImEye
                          onClick={() => {
                            setShowPassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <RiEyeCloseLine
                          onClick={() => {
                            setShowPassword(true);
                          }}
                        />
                      </>
                    ),
                  },
                ]}
                footer={<></>}
              />
              <Row className="form-button-row">
                <Button type="submit">{string.ACCOUNT_UPDATE}</Button>
              </Row>
            </Form>
          </>
        }
      />
    </>
  );
};

export default UserUpdate;
